export default class Semaphore {
  #waiting = []

  #locked = false

  acquire() {
    return new Promise((resolve) => {
      if (this.#locked) {
        this.#waiting.push(resolve)
      } else {
        this.#locked = true
        resolve()
      }
    })
  }

  release() {
    if (this.#waiting.length > 0) {
      const next = this.#waiting.shift()
      next()
    } else {
      this.#locked = false
    }
  }
}
